module.exports = __webpack_public_path__ + "assets/img/Rules_btn.7e77b547.png";